<template>
  <div id="app">
    <a-config-provider :locale="zhCN">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
  name: 'App',
  data() {
    return {
      zhCN,
    };
  }
};
</script>

<style lang="less">
#app {
  font-family: HiraginoSansGB-W6, HiraginoSansGB;
}

body {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  // overflow: hidden;
}

body #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  // height: 100%;
  width: 100%;
}

body #app #office-iframe {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  width: 1201px;
  height: 669px;
  /* 防止双击缩放 */
  touch-action: manipulation;
}
</style>
